export const currencyMask = (e) => {
  let { value } = e.target;
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d)(\d{2})$/, '$1,$2');
  value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
  e.target.value = value;
  return e;
};
export const currencyMaskString = (value) => {
  let strValue = value.toFixed(2).toString();
  strValue = strValue.replace(/\D/g, '');
  strValue = strValue.replace(/(\d)(\d{2})$/, '$1,$2');
  strValue = strValue.replace(/(?=(\d{3})+(\D))\B/g, '.');
  return strValue;
};
export const dateMask = (e) => {
  let { value } = e.target;
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d)(\d{4})$/, '$1/$2');
  value = value.replace(/(?=(\d{2})+(\D))\B/g, '/');
  e.target.value = value;
  return e;
};
